/* custom (Second Edition): keep the alternate view in native catalog requests. */
(() => {
  if (window.seFallKickoffInitialized) return;
  window.seFallKickoffInitialized = true;

  function initialize() {
    const hero = document.querySelector('[data-se-fall-hero]');
    if (!hero) return;
    const saleView = hero.dataset.saleView === 'true';
    const grid = document.getElementById('ProductGridContainer');
    const catalog = grid && grid.closest('.shopify-section');
    // Owner 2026-09-29: the sale page address follows the event (fall-refresh); read it from the page's template
    // instead of a fixed name, so filters, sorting and paging stay on whichever sale view is open.
    const view = hero.dataset.view || 'fall-kickoff';

    function carryValues(form, name, values) {
      const inputs = Array.from(form.querySelectorAll('input[data-se-fall-param]')).filter((input) => input.name === name);
      if (inputs.length === values.length && inputs.every((input, index) => input.value === values[index])) return;
      inputs.forEach((input) => input.remove());
      values.forEach((value) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        input.dataset.seFallParam = name;
        form.appendChild(input);
      });
    }

    function preserveCatalogState(form, params) {
      // The native engine submits only the changed form. Carry the other controls' state.
      const nativeControls = Array.from(form.querySelectorAll('[name]:not([data-se-fall-param])'));
      if (!nativeControls.some((input) => input.name === 'sort_by')) {
        carryValues(form, 'sort_by', params.getAll('sort_by'));
      }
      if (!form.closest('.facets--bar')) return;
      const filterNames = new Set(Array.from(params.keys()).filter((name) => name.startsWith('filter.')));
      form.querySelectorAll('input[data-se-fall-param]').forEach((input) => {
        if (input.name.startsWith('filter.')) filterNames.add(input.name);
      });
      filterNames.forEach((name) => {
        const values = nativeControls.some((input) => input.name === name) ? [] : params.getAll(name);
        carryValues(form, name, values);
      });
    }

    function preserveLink(link) {
      if (!saleView || !link) return;
      const url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
      if (url.searchParams.get('view') === view) return;
      url.searchParams.set('view', view);
      link.href = url.pathname + url.search + url.hash;
    }

    function refresh() {
      const params = new URLSearchParams(window.location.search);
      if (hero.dataset.hideAfterFirst === 'true') {
        hero.hidden = Number(params.get('page') || 1) > 1;
      }
      if (!catalog) return;
      catalog.querySelectorAll('facet-filters-form form').forEach((form) => {
        preserveCatalogState(form, params);
        if (!saleView) return;
        let input = form.querySelector('input[name="view"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'view';
          input.value = view;
          form.appendChild(input);
        } else {
          input.value = view;
        }
      });
      catalog.querySelectorAll('facet-remove a, pagination-theme a, .collection-empty a').forEach(preserveLink);
    }

    refresh();
    if (catalog) {
      // Native facets replace their forms and links after every AJAX response.
      new MutationObserver(refresh).observe(catalog, { childList: true, subtree: true });
      catalog.addEventListener('click', (event) => {
        preserveLink(event.target.closest('facet-remove a, pagination-theme a, .collection-empty a'));
      }, true);
      catalog.addEventListener('input', refresh, true);
    }
    window.addEventListener('popstate', refresh);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
